import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

import loginPlugin from '@/plugins/loginPlugin'

import Store from './store/index'
import Axios, { request } from '@utils/axios'
import * as Elicons from '@element-plus/icons-vue'
import { hasPermission, hasAnyPermission, restorePermissions, clearPermissions } from '@utils/permission.js'

import '@assets/css/main.scss'

// 应用启动时从缓存恢复权限，避免首屏按钮闪烁
restorePermissions()

const app = createApp(App)
app.provide('$axios', request)

// 注册全局权限指令 v-permit
// 用法：<el-button v-permit="'order:export'">导出</el-button>
// 支持数组：<el-button v-permit="['a','b']">任一有权限即显示</el-button>
app.directive('permit', {
  mounted(el, binding) {
    const keyword = binding.value
    if (!keyword) return
    const allowed = Array.isArray(keyword)
      ? hasAnyPermission(keyword)
      : hasPermission(keyword)
    if (!allowed) {
      el.parentNode?.removeChild(el)
    }
  }
})



for (const name in Elicons) {
  app.component(name, Elicons[name])
}

app.use(router)
.use(Store)
.use(Axios)
.use(loginPlugin)


app.mount('#app')
